// @flow

import type {Language, ModalProps} from '@/types'

import React from 'react'
import {connect} from 'react-redux'
import {mergeAll} from 'ramda'
import {appSelectors, portfoliosActions, portfoliosSelectors, uiActions} from '@/store'

type Props = {
  name: string,
  deleteActivePortfolio: () => void,
  showConfirmModal: (props: ModalProps) => void,
  l: Language,
}

const RawDeletePortfolioButton = (props: Props) =>
  <button id='delete_portfolio'
    className="btn btn-danger truncate"
    style={{'maxWidth': '130px', 'marginRight': '-20px'}}
    type="button"
    onClick={() => props.showConfirmModal({
      onConfirm: props.deleteActivePortfolio,
      message: 'This will remove the portfolio and the companies monitored within.',
    })}
  >
    {props.l('Delete portfolio')}
  </button>

const mapStateToProps = (state) => ({
  name: portfoliosSelectors.getActivePortfolioName(state),
  l: appSelectors.getL(state),
})

export default connect(
  mapStateToProps,
  mergeAll([portfoliosActions, uiActions]),
)(RawDeletePortfolioButton)



// WEBPACK FOOTER //
// ./src/views/portfolios-page/delete-portfolio-button.js